// Estados da máquina de estados do sistema de convites
export const STATES = {
  LOADING: 'LOADING',               // Carregando dados
  ALREADY_LINKED: 'ALREADY_LINKED', // Usuário já vinculado com o mesmo profissional
  INVALID_CODE: 'INVALID_CODE',     // Código inválido ou expirado
  NO_INVITE: 'NO_INVITE',           // Nenhum convite encontrado
  HAS_LINK: 'HAS_LINK',             // Usuário já tem vínculo com outro profissional
  NO_LINK: 'NO_LINK',               // Usuário não tem vínculo ainda
  SUCCESS: 'SUCCESS',               // Vinculação realizada com sucesso
  REJECTED: 'REJECTED',             // Convite recusado
  UNLINK_PROFILE: 'UNLINK_PROFILE', // Tela para desvincular perfil
  UNLINK_SUCCESS: 'UNLINK_SUCCESS', // Desvinculação realizada com sucesso
  UNLINK_ERROR: 'UNLINK_ERROR',      // Erro na desvinculação
  PROFESSIONAL_BLOCKED: 'PROFESSIONAL_BLOCKED', // Profissional tentando se vincular a outro profissional
  SELF_INVITE_BLOCKED: 'SELF_INVITE_BLOCKED' // Usuário tentando se vincular a si mesmo
};

// Status HTTP relevantes para a API de convites
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  USED_CODE: 410, // Código já usado (Gone)
  INTERNAL_SERVER: 500
};